module.exports = __webpack_public_path__ + "static/media/food-pairing-icon.f0330bc0.svg";